/** In-app User Guide (`/w/:ws/guide`): page chrome only. The guide topics themselves are English content data. */
export const guide = {
  title: "User Guide",
  subtitle: "Step-by-step help for everything in Sagot. Search, or browse by area.",
  searchLabel: "Search the guide",
  searchPlaceholder: "Search, e.g. “add a document”",
  searchClear: "Clear search",
  developerDocs: "Developer docs",
  modulesLabel: "Guide areas",
  moduleSelect: "Area",
  allTopics: "All topics",
  topicCount_one: "{{count}} topic",
  topicCount_other: "{{count}} topics",
  stepCount_one: "{{count}} step",
  stepCount_other: "{{count}} steps",
  resultsFor_one: "{{count}} topic matches “{{query}}”",
  resultsFor_other: "{{count}} topics match “{{query}}”",
  resultsHeading: "Search results",
  noResultsTitle: "Nothing matches “{{query}}”",
  noResultsBody: "Check the spelling, try fewer or simpler words, or browse the guide by area.",
  noResultsInModule: "No topic in {{module}} matches “{{query}}”. Try all areas.",
  clearSearch: "Clear search",
  showAllAreas: "Search all areas",
  suggestionsHeading: "Good places to start",
  emptyTitle: "The guide is on its way",
  emptyBody: "Step-by-step guides will appear here. In the meantime the developer docs cover the API.",
  notFoundTitle: "We couldn't find that guide",
  notFoundBody: "It may have been renamed. Search for what you need, or browse the guide by area.",
  backToGuide: "Back to the User Guide",
  breadcrumb: "Guide path",
  audienceLabel: "Who can do this",
  planBadge: "{{plan}} plan and up",
  before: "Before you start",
  steps: "Steps",
  stepLabel: "Step {{n}}",
  result: "What you should see",
  tips: "Tips",
  related: "Related guides",
  pagerLabel: "More in this area",
  previous: "Previous",
  next: "Next",
  openPage: "Open {{page}}",
  enlarge: "Enlarge screenshot: {{alt}}",
  shotDialogTitle: "Step {{n}} screenshot",
  shotUnavailable: "This screenshot couldn't load.",
  paletteGroup: "User Guide",
  loadingLabel: "Loading the guide",
} as const;
